import type { FC } from "react";
import { defaultUnderlineStyle } from "@ecco/ui/css/common";
import { useMemo } from "react";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";
import { Text } from "@ecco/ui/text";
export const deleteAccountFormWrapper = "delete-account-form-wrapper";
export const customerServiceLink = "customer-service-link";

export const DeleteAccountForm: FC = () => {
    const { getMultiple } = useMicrocopy();
    const namedMC = {
        supportEmail: "supportEmailAccount",
        contactText: "uiText.contactText",
        customerService: "uiText.customerService",
    };

    const microcopies = useMemo(() => {
        return getMultiple(CommonCMS.page, Object.values(namedMC));
    }, []);

    return (
        <Text
            color="black"
            fontWeight={"bold"}
            fontSize={["mobileBodyB2", "desktopBodyB2"]}
            data-testid={deleteAccountFormWrapper}
        >
            {microcopies[namedMC.contactText]}{" "}
            <a
                href={`mailto:${microcopies[namedMC.supportEmail]}`}
                style={defaultUnderlineStyle}
                data-testid={customerServiceLink}
            >
                {microcopies[namedMC.customerService]}
            </a>
        </Text>
    );
};

export default DeleteAccountForm;
